import API from './commons/Api.js';
import router from './commons/Router.js';
import { eventBus, EVENTS } from './commons/EventBus.js';
import Utils from './commons/utils.js';
import {Paginator} from "./commons/paginator.js";
var downloadTimer;
var question_nr=0;
window.points = 0;
var alpha="abcdefghijklmnopqrstuvwxyz";
eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {
    const template=data.template;
    if(template!='gioco-fan-landing'){
        return;
    }

    window.spunte_accettazione = "";
  $('.gioco-fanize-information-read').off().click(function() {

    question_nr=0;
    window.points = 0;
    clearInterval(downloadTimer);

      if (!user.checkUser()) {
            user.openLoginPopupGame(location.href);
            return;
       }
        if($(this).hasClass("contest")){
          if(!window.spunte_accettazione){
              window.spunte_accettazione = $("#spunte_accettazione_fanize").html();
          }
          Utils.accettaContest("Per continuare leggi e accetta il regolamento e l'informativa sulla privacy.",window.spunte_accettazione,()=> {
            var contest_id = $("#mission_id_fanize").html();
            $("#spunte_accettazione_fanize").empty();

            var rule = false;
            var privacy = false;
            if($("#spunta_regole_contest").length > 0 && $("#spunta_regole_contest").is(':checked')){
              rule = true;
            } else if($("#spunta_regole_contest").length > 0 && $("#spunta_regole_contest").is(':checked')){
              return;
            }

            if($("#spunta_privacy_contest").length > 0 && $("#spunta_privacy_contest").is(':checked')){
              privacy = true;
            } else if($("#spunta_privacy_contest").length > 0 && !$("#spunta_privacy_contest").is(':checked')){
              return;
            }
            var data = {
              "missionId":contest_id,
              "acceptedGameRule":rule,
              "acceptedGamePrivacy":privacy
            }

            API.postOnFanize("campaigns/" + window.campaignId + "/users/missions/user-acceptance", data,  (r) => {

              if(r.meta.status == 200){
                $(this).removeClass("contest");
                $(".popup-messaggio-main").hide();
              }
            });

          }, ()=> {



          }, "CONTINUA", "ANNULLA");

          return;
        }


      if($(this).attr("data-type") == "instantwin.random"){
        explainInstantRandom($(this).attr("data-id"))
      } else{
        getInfoGiochiFanize($(this).attr("data-id"),$(this).attr("data-type"))
      }
  });

    $('.go-to-giochi').off().click(function() {
        replaceNavigation("/gioca");
    });
});

window.getInfoGiochiFanize = function(id_gioco, type){
  var path = "";

  if(type == "information.read"){
    path = "/information/"+id_gioco;
  } else if(type == "answer.question" || type == "answer.survey"){
    path = "/surveys/"+id_gioco+"/questions";
  } else if(type == "answer.instantwin"){
    // getInfoQuizTempo(id_gioco);
    path = "/instantwins/"+id_gioco;
    // return;
  } else if(type == "prediction"){
    path = "/predictions/"+id_gioco+"/questions";
  } else if(type == "customevent.video"){
    path = "/videos/"+id_gioco;
  } else if(type == "customevent.download"){
    downloadContent(id_gioco);
    return;

  }
  /*
  API.getOnFanize("campaigns/" + window.campaignId + path, {}, function (resp) {

    $(".blocco_gioco_fanize").hide(); ////nascondo la landing del gioco
    $(".container_gioco_fanize").empty();
    $(".container_gioco_fanize").append(`<div class='position-center background_cont'>
                                          <div id="fanize-content-info" class="sofia_font font_30 bold"></div>
                                            <div id="select_risposta_quest" class="width_full margin_top"></div>
                                            <div id="blocco_domande_step" class="width_full">
                                           <div class="c-timer" id="countdownbar">
                                              <svg viewBox="0 0 120 120" class="c-timer__svg">
                                                  <circle cx="60" cy="60" r="45" stroke-width="12" stroke="" class="bkg_circle"></circle>
                                                  <circle cx="60" cy="60" r="54" stroke-width="6" stroke="rgba(43, 51, 123, 0.14)" class="progress__meter"></circle>
                                                  <circle cx="60" cy="60" r="54" stroke-width="7" stroke-dasharray="339" id="circle_countdown" style="stroke-dashoffset:0;fill:none;" stroke="#0F4F9B" class="progress__value"></circle>
                                              </svg>
                                              <div data-v-7c557592="" class="c-timer__count"></div>
                                            </div>
                                            </div>
                                            <div id="blocco_video" class="width_full"></div>
                                          <input id="input_risposta" type="text" class="sofia_font input_risposta_aperta"  placeholder="Scrivi qualcosa...">
                                          <div class='popup-conferma-button flex'>
                                              <div id="btnPartecipa" class='popup-conferma-close disabled font_16 bold button skew uppercase' style="margin-top: 20px;"></div>
                                          </div>
                                      </div>`);


    var content = "";
    var cta = "";
    var id_risposta;
    var input_type="text";

    if(type == "information.read"){

      $(".background_cont").css("background", "white");
      content = resp.data.content;
      cta = resp.data.cta;
      $("#btnPartecipa").removeClass("disabled");
      popupGiochiFanize(content,cta, ()=>{getCoin(type, id_gioco)} , type, input_type)
    } else if(type == "answer.question"){

      content = resp.data[0].text;
      cta = "INVIA";
      input_type = resp.data[0].type;
      id_risposta= resp.data[0]["id"];
      var image = "";
      if(resp.data[0].image){
        image = `<img class="image_question" src="${resp.data[0].image}">`;
        $("#fanize-content-info").after(image);
      }
      $("#input_risposta").attr("data-idrisposta", id_risposta);
      if(input_type == "select" || input_type == "multi-select"){
          $("#input_risposta").after(`<div id="select_risposta_quest"></div>`);
          var single_opt;
          for (let i = 0; i < resp.data[0].options.length; i++) {
            single_opt = resp.data[0].options[i];

            // $("#select_risposta_quest").append(`<input type="${input_type == "select" ? "radio" : "checkbox"}" name="answer-question" value="${single_opt.id}">${single_opt.text}`)
            $("#select_risposta_quest").append(` <div class="sofia_font font_12 flex align_center" style="margin-bottom:20px;">
                                                        ${image}
                                                        <label class="container_checkbox_domanda more_questions">
                                                            <input  style="display: none;" type="${input_type == "select" ? "radio" : "checkbox"}" value="${single_opt.id}" class="checkbox-giochi"  name="answer-questione">
                                                            <span  style="display: none;" class="check_giochi_domanda checkbox-giochi"></span>
                                                            <span class="font_16" style="padding-left: 15px;">${single_opt.text}</span>
                                                        </label>
                                                    </div>`);


          }
      }


      popupGiochiFanize(content,cta, ()=>{getCoin(type, id_gioco)} , type, input_type);
    } else if(type == "answer.survey" || type == "prediction"){
      popupMoreQuestions(resp, id_gioco, type);
    } else if(type == "answer.instantwin"){

      question_nr =0;
      $("#btnPartecipa").html("AVANTI");
      popupQuizATempo(resp.data, id_gioco);
    } else if(type == "customevent.video"){
      $("#blocco_video").append(`<video id="video_fanize" class="width_full" autoplay src="${resp.data.link}"></video>`);
      $("#btnPartecipa").hide();
      document.getElementById('video_fanize').addEventListener('ended',(e)=>{getCoin(type, id_gioco)},false);
    }

  }, function () {
    Utils.hideWaitingLoader();
  });
  */
}
window.explainQuizatempo = function(id_gioco, domande, sec_per_q){
  var content = "Rispondi correttamente alle domande nel minor tempo possibile.";
  content += "Ci sono "+ domande + " domande e hai "+sec_per_q+" per rispondere ad ognuna";
  popupGiochiFanize(content,"INIZIA", ()=>{startInstantWin(sec_per_q)} , "answer.instantwin");
}



window.explainInstantRandom = function(id_gioco){
  $(".blocco_gioco_fanize").hide(); ////nascondo la landing del gioco
  $(".container_gioco_fanize").empty();
  $(".container_gioco_fanize").append(`<div class='position-center background_cont'>
                                         <div id="card_rotante">
                                            <img class="img_rotante" src="https://media.rds.it/web/web-site-brandnew/svg/card_rotante.svg">
                                         </div>
                                          <div id="fanize-content-info" class="sofia_font font_30 bold"></div>
                                          <div class='popup-conferma-button flex'>
                                              <div id="btnPartecipa" class='popup-conferma-close font_16 bold button skew uppercase' style="margin-top: 20px;"></div>
                                          </div>
                                      </div>`);
  popupGiochiFanize("Ti senti fortunato?","SONO PRONTO", ()=>{startInstantWinRandom(id_gioco)} , "instantwin.random");
}

window.startInstantWinRandom = function(id_gioco){
  ////TODO chiamata fanize per start del gioco che decide se vinci o perdi
  $("#card_rotante").addClass("rotating");
  $("#btnPartecipa").css("opacity", ".3")
  $('#btnPartecipa').off().click();


  var path = "/instantwinsRandom/"+id_gioco+"/play";

  API.postOnFanize("campaigns/" + window.campaignId + path, {}, function (resp) {

    //// se la risposta è resp.meta.status == 409 allora l'utente ha già giocato; TODO
    setTimeout(function(){
      $("#card_rotante").removeClass("rotating");
      $(".img_rotante").css("visibility", "hidden");

      $("#btnPartecipa").css("opacity", "1")

      if(resp.data.won){
        $("#fanize-content-info").html("Wow, è la tua giornata!");
        $("#card_rotante").addClass("win");
        $("#card_rotante").append("<span class='testo_card sofia_font'>HAI VINTO!</span>");
        $('#btnPartecipa').html("RISCATTA IL PREMIO")
        $('#btnPartecipa').off().click(function() {
          getCoin("instantwin.random", id_gioco);
        });
      } else{
        $("#fanize-content-info").html("Oh no, sarà per la prossima!");
        $("#card_rotante").addClass("lost");
        $("#card_rotante").append("<span class='testo_card sofia_font'>HAI PERSO!</span>");
        $('#btnPartecipa').html("TORNA AI GIOCHI")
        $('#btnPartecipa').off().click(function() {
          addNavigation("/gioca");
        });
      }
    }, 4000)

  });
  // nstantwinsRandom/{{instantwinRandomId}}/play



}

function startInstantWin(sec_per_q){
  $("#fanize-content-info").after(`<!--<progress max="${sec_per_q}" id='countdownbar'></progress><div id="countdownbar_text"></div>-->`);
  // $("#fanize-content-info").after(`<div id='countdownbar_cont'><div id="countdownbar"></div></div><div id="countdownbar_text"></div>`);
  nextQuestion(sec_per_q);

}
// function nextQuestion(sec_per_q){
//
//   ////API NEXT QUESTION
//   clearInterval(downloadTimer);
//   popupGiochiFanize("domanda","AVANTI", ()=>{nextQuestion(sec_per_q)} , "answer.instantwin");
//   startCountdown(sec_per_q);
// }
function startCountdown(id_gioco){
  $("#countdownbar").show();

  var element = document.getElementById("circle_countdown");
  // $("#circle_countdown").removeClass("progress__value").addClass('progress__value');
  document.getElementById("circle_countdown").classList.remove("progress__value");
  setTimeout(function(){
    if(document.getElementById("circle_countdown")){
      document.getElementById("circle_countdown").classList.add("progress__value");
      document.getElementById("circle_countdown").style.animationPlayState = 'running';
    }
  }, 100);

  var sec_per_q = getComputedStyle(document.documentElement).getPropertyValue('--durata-gioco');

  var timeleft = parseInt(sec_per_q);
  var secondi = 0;
  downloadTimer = setInterval(function(){
    timeleft -= 1;
    secondi += 1;
    $("#circle_countdown").attr("data-sec", secondi);
      $(".c-timer__count").text(timeleft+"s");

    if(timeleft <= 15){
      element.style.stroke = "#EF3824"
    } else if(timeleft <= 30){
      element.style.stroke = "#FECB32"
    } else{
      element.style.stroke = "#0F4F9B"
    }

    if(timeleft == 0){
      if(document.getElementById("circle_countdown")){
        document.getElementById("circle_countdown").style.animationPlayState = "paused";
      }
      clearInterval(downloadTimer);
      rispondiQuizTempo(id_gioco);
    }

  }, 1000)
}

window.popupQuizATempo = function(resp, id_gioco) {

  const cssVar = '--durata-secondi-gioco';
  const cssVar2 = '--durata-gioco';
  const root = document.documentElement;
  root.style.setProperty(cssVar2, resp.max_seconds_per_question);
  root.style.setProperty(cssVar, resp.max_seconds_per_question+"s");
  $(".c-timer__count").text(resp.max_seconds_per_question+"s");


  $("#countdownbar").show();

  $("#blocco_domande_step").append(`<div id="linea_num_domande_quiz" class="pos_relative">
                                        <div id="cont_absolute_domande"></div>
                                     </div>
                                     <div class="text_center bold sofia_font"><span id="numero_current_survey">${question_nr}</span> / ${resp.questions_count}</div>
                                     <div id="contenitore_single_domanda_step"></div>`);
  for (let i = 0; i < resp.questions_count; i++) {
      $("#cont_absolute_domande").append(`<div class="linea_single_domanda_quiz" data-index="${i + 1}" style="width:calc(100% / ${resp.questions_count})"></div>`);
  }
  getCurrentQuestion(id_gioco);
};


function getCurrentQuestion(id_gioco){

  /*
  API.getOnFanize("campaigns/" + window.campaignId + "/instantwins/"+id_gioco+"/question", {}, function (resp) {

    startCountdown(id_gioco);
    if(resp.data){
      $(".single_survey.current_domanda").remove();
      question_nr += 1;
      $("#numero_current_survey").text(question_nr);

      $(".linea_single_domanda_quiz[data-index='"+question_nr+"']").addClass("completed");
        var domanda = resp.data.question;
        var single_answ;
        var image = "";
        var input = "";
          for (let j = 0; j < resp.data.answers.length; j++) {
            single_answ = resp.data.answers[j];
            input +=
              `  <div class="sofia_font font_12 flex align_center pos_relative" style="margin-bottom:20px;">
                                                            <div class="lettera_domanda"><span>${alpha[j]}</span></div>
                                                            <label class="container_checkbox_domanda tipo_quiz">
                                                                <input  style="display: none;" type="radio" value="${single_answ.id}" class="checkbox-giochi input_domanda_quiz"  name="answer-option-quiz">
                                                                <span  style="display: none;" class="check_giochi_domanda checkbox-giochi"></span>
                                                                <span class="font_16" style="padding-left: 15px;">${single_answ.text}</span>
                                                            </label>
                                                        </div>`;

          }
        if(resp.data.image){
          image = `<img src="${resp.data.image}">`;
        } else{
          image = "";
        }

        $("#contenitore_single_domanda_step").append(`<div class="single_survey current_domanda">
                                            <div class="sofia_font font_30 bold testo_domanda_quiz" style="width:80%;">${domanda}</div>
                                            <div>${image}</div>
                                            <div>${input}</div>
                                      </div>`)

        $('#btnPartecipa').addClass("disabled");

        $('.input_domanda_quiz').off().click(function() {
          rispondiQuizTempo(id_gioco);
        });


    } else{ ///era l'ultima domanda
      getCoin("answer.instantwin", id_gioco);
    }



  });
   */
}




function rispondiQuizTempo(id_gioco){

  if(document.getElementById("circle_countdown")) {
    document.getElementById("circle_countdown").style.animationPlayState = "paused";
  }
  clearInterval(downloadTimer);

  var secondi = $("#circle_countdown").attr("data-sec");

  var int_sec = parseInt(secondi);
  if(secondi >= getComputedStyle(document.documentElement).getPropertyValue('--durata-gioco')){
    int_sec += 5;
  }

  var id_risposta = $("input[name='answer-option-quiz']:checked").val();

  var data = {"answer":id_risposta,"seconds":int_sec}; //TODO contare secondi
  API.postOnFanize("campaigns/" + window.campaignId + "/instantwins/"+id_gioco+"/answer", data, function (resp) {
    console.log(resp);


    if(resp.meta.status == 400){
      /////gioco finito.
      // getCoin("answer.instantwin", id_gioco);
      // return;
    }

    if(resp.data && resp.data.correct){
      window.points += resp.data.points;
      // $("input[name='answer-option-quiz']:checked").parents(".container_checkbox_domanda").addClass("correct");
      $(".linea_single_domanda_quiz[data-index="+question_nr+"]").addClass("correct");
      $("input[name='answer-option-quiz']:checked").parents(".container_checkbox_domanda").addClass("correct").append("<img class=\"image_corr_inco\" src=\"https://media.rds.it/web/web-site-brandnew/corretta.png\">");
    } else{
      $(".linea_single_domanda_quiz[data-index="+question_nr+"]").addClass("incorrect");
      $("input[name='answer-option-quiz']:checked").parents(".container_checkbox_domanda").addClass("incorrect").append("<img class=\"image_corr_inco\" src=\"https://media.rds.it/web/web-site-brandnew/error.svg\">");
    }


    $('#btnPartecipa').removeClass("disabled");
    $('#btnPartecipa').off().click(function() {
      if(!$(this).hasClass("disabled")){
          getCurrentQuestion(id_gioco);
      }
    });

  }, function(e){

    $(".linea_single_domanda_quiz[data-index="+question_nr+"]").addClass("incorrect");
    getCurrentQuestion(id_gioco);
  });

}


window.popupMoreQuestions = function(resp, id_gioco, type) {

  $("#blocco_domande_step").append(`<div id="linea_num_domande" class="pos_relative">
                                        <div id="cont_absolute_domande"></div>
                                     </div>
                                     <div class="text_center bold sofia_font"><span id="numero_current_survey">1</span> / ${resp.data.length}</div>
                                     <div id="contenitore_single_domanda_step"></div>`);
  for (let i = 0; i < resp.data.length; i++) {

      $("#cont_absolute_domande").append(`<div class="linea_single_domanda ${i == 0 ? 'completed' : ''}" data-index="${i + 1}" style="width:calc(100% / ${resp.data.length})"></div>`);

    var single_opt;
    var domanda;
    var image = "";
    var input = "";

    single_opt = resp.data[i];
    domanda = single_opt.text;
    if(single_opt.type == "select" || single_opt.type == "multi-select"){
      for (let j = 0; j < single_opt.options.length; j++) {
        var option = single_opt.options[j];

        input +=
        `  <div class="sofia_font font_12 flex align_center" style="margin-bottom:20px;">
                                                        <label class="container_checkbox_domanda more_questions">
                                                            <input  style="display: none;" type="${single_opt.type == "select" ? "radio" : "checkbox"}" value="${option.id}" class="checkbox-giochi"  name="answer-option-${single_opt.id}">
                                                            <span  style="display: none;" class="check_giochi_domanda checkbox-giochi"></span>
                                                            <span class="font_16" style="padding-left: 15px;">${option.text}</span>
                                                        </label>
                                                    </div>`;
      }
    } else{
      input = `<input data-value="${single_opt.id}" class="input_risposta_aperta" type="${single_opt.type}">`;
    }
    if(single_opt.image){
      image = `<img src="${single_opt.image}">`;
    } else{
      image = "";
    }


    $("#contenitore_single_domanda_step").append(`<div class="single_survey ${i == 0 ? 'current_domanda' : ''}" data-index="${i + 1}" data-value="${single_opt.id}">
                                        <div class="sofia_font font_30 bold margin_bottom text_center">${domanda}</div>
                                        <div>${image}</div>
                                        <div>${input}</div>
                                  </div>`)
  }


  try {

    $('#btnPartecipa').html("AVANTI");
    $(".popup-gioco-fanize").show();
    $("#array_questions").show();
    $('#btnPartecipa').off().click(function() {
      nextQuestionSurvey(id_gioco, type);
      ////invio domande
    });


  } catch (err) {
    console.log(err);
  }



}

function nextQuestionSurvey(id_gioco, type){

  var current = $(".single_survey.current_domanda");
  $("#btnPartecipa").addClass("disabled");
  if(current.find("input:checked").length > 0 ||
    (current.find("input[type='text']").length > 0 && current.find("input[type='text']").val() != "") ||
    (current.find("input[type='number']").length > 0 && current.find("input[type='number']").val() != "")) {

    if(current.next(".single_survey ").length == 0){
      // return;
      getCoin(type, id_gioco)

    } else{

      current.removeClass("current_domanda").next(".single_survey ").addClass("current_domanda");
      var index_new = $(".single_survey.current_domanda").attr("data-index");
      $("#numero_current_survey").html(index_new);

      $(".linea_single_domanda[data-index='"+index_new+"']").addClass("completed");
    }
  } else{

  }






}


window.popupGiochiFanize = function(content, yesButton, yesCallback, type, input_type) {

  try {
    $('#btnPartecipa').html(yesButton);
    $("#fanize-content-info").html(content);


    if(type=="answer.question" || type=="prediction" ){

      if(input_type != "select" && input_type != "multi-select"){
        $("#input_risposta").attr("type", input_type);
        $("#input_risposta").show();
      } else{
        $("#input_risposta").hide();
      }
    } else{

      $("#input_risposta").hide();
      $("#select_risposta_quest").hide();
    }

    $('#btnPartecipa').off().click(function() {
        if(!$(this).hasClass("disabled")){
          $(".popup-gioco-fanize").hide();
          yesCallback();
        }
      });


  } catch (err) {
    console.log(err);
  }

};




window.getCoin = function(type, id_gioco){

  var path;
  var data_answers = {};
  if(type == "answer.question"){
    data_answers["answers"] = [];
    var id_risposta = $("#input_risposta").attr("data-idrisposta");
    var value = $("#input_risposta").val();
    if($("#select_risposta_quest").find(".container_checkbox_domanda").length > 0){s

      value = [];
      $(".checkbox-giochi:checked").each(function(){
        value.push($(this).val());
      });

    }
    data_answers["answers"].push({"id" : id_risposta, "answer": value});
    path= "/surveys/"+id_gioco+"/answers"
  } else if(type == "prediction"){
    data_answers["answers"] = [];
    path= "/predictions/"+id_gioco+"/submissions";
    $(".single_survey").each(function(){

      data_answers["answers"].push({"id" : $(this).attr("data-value"), "answer": $(this).find(".checkbox-giochi:checked").val()});
    });
  } else if(type == "information.read"){
    path = "/information/"+id_gioco;
  } else if(type == "customevent.video"){
    path = "/videos/"+id_gioco+"/seen";
  } else if(type == "answer.survey"){
    data_answers["answers"] = [];
    path= "/surveys/"+id_gioco+"/answers";

    $(".single_survey").each(function(){
      var value;
      var id_risposta = $(this).attr("data-value");
      if($(this).find(".input_risposta_aperta").length > 0){
        value = $(this).find(".input_risposta_aperta").val();

      } else{
        value = [];
        $(".checkbox-giochi:checked").each(function(){
          value.push($(this).val());
        });

      }
      data_answers["answers"].push({"id" : id_risposta, "answer": value});
    });

  } else if(type == "answer.instantwin" || type == "instantwin.random"){
    ////TO DO
    // return;
    $("#titolo_gioco_fanize").text("Complimenti!");
    $("#desc_gioco_fanize").text("La fortuna oggi era dalla tua e hai guadagnato ben:");
    $(".container_gioco_fanize").remove();
    $(".blocco_gioco_fanize").show();
    $("#blocco_vincita_resp").show();
    if(type == "answer.instantwin"){
      $("#punti_guadagnati").text(window.points);
    }
    $("#blocco_iniziale_gioco").hide();
    return;
  } else if(type == "customevent.download"){
    $("#titolo_gioco_fanize").text("Complimenti!");
    $("#desc_gioco_fanize").text("Download completato, hai guadagnato:");
    $(".container_gioco_fanize").remove();
    $(".blocco_gioco_fanize").show();
    $("#blocco_vincita_resp").show();
    $("#blocco_iniziale_gioco").hide();
    return;
  }

  API.postOnFanize("campaigns/" + window.campaignId + path, data_answers, function (resp) {

    $("#titolo_gioco_fanize").text("Complimenti!");
    $("#desc_gioco_fanize").text("La fortuna oggi era dalla tua e hai guadagnato ben:");
    $(".container_gioco_fanize").remove();
    $(".blocco_gioco_fanize").show();
    $("#blocco_vincita_resp").show();
    $("#blocco_iniziale_gioco").hide();
  });

};

$(document).on('change','#dettaglio-gioco-ugc-liberatoria', (e)=>{
    $("#dettaglio-gioco-ugc-liberatoria-readonly").val(e.target.files[0].name);
});

$(document).on('keyup','#input_risposta', function(){
    if($(this).val().length > 0 ){
      $("#btnPartecipa").removeClass("disabled");
    }else{
      $("#btnPartecipa").addClass("disabled");
    }
});

$(document).on('change','#input_risposta[type=date], #input_risposta[type=number], .input_risposta_aperta', function(){
    if($(this).val().length > 0 ){
      $("#btnPartecipa").removeClass("disabled");
    }else{
      $("#btnPartecipa").addClass("disabled");
    }
});

$(document).on('keyup','.input_risposta_aperta', function(){ /////abilitare bottone avanti su survey
      if($(this).parents(".current_domanda")){
      if($(this).val().length > 0 ){
        $("#btnPartecipa").removeClass("disabled");
      }else{
        $("#btnPartecipa").addClass("disabled");
      }
    }
});


window.closePopupFanize = function(){
  $('.popup-gioco-fanize').hide();
  $("#countdownbar").hide();
  $("#countdownbar_text").hide();
  clearInterval(downloadTimer);
}


function downloadContent(id_gioco){
  var path = "/events/"+id_gioco+"/download";

  /*
  API.getOnFanize("campaigns/" + window.campaignId + path, {}, function (resp) {
    console.log(resp.link);
    $(".container_gioco_fanize").append(`<a href="${resp.link}" style="display:none;" id="click_per_download"></a>`);
    $("#click_per_download").click();
    getCoin("customevent.download", id_gioco);

  });
   */
}

$(document).on('change','.checkbox-giochi', function(){ /////abilitare bottone avanti su survey
  if ($(this).is(':checked')) {
    console.log("Checkbox is checked..")
    $("#btnPartecipa").removeClass("disabled");

  } else {
    console.log("Checkbox is not checked..")
    $("#btnPartecipa").addClass("disabled");

  }
});
